<template>
  <div class="diabox">
    <template v-if="data">
      <div class="exp">
        <div><div>特店交易編號</div><div>{{data.orderId}}</div></div>
        <div><div>LINE交易編號</div><div>{{transactionId}}</div></div>
        <div><div>交易金額</div><div>{{data.currency}} {{formatDollarInt(amount)}}</div></div>
        <div><div>付款時間</div><div>{{moment(data.transactionDate).format('YYYY-MM-DD HH:mm')}}</div></div>
        <div><div>付款類型</div><div>{{data?.transactionType}}</div></div>
        <div><div>交易狀態</div><div>{{data.payStatus}}</div></div>
        <template v-if="refundList && refundList.length > 0">
          <hr>
          <div><div>付款資訊</div><div></div></div>
          <ul class="refundList">
            <li v-for="(prod, p) in payInfo" :key="`refund-${p}`">
              <div>{{prod.method}}</div>
              <div>{{formatDollarInt(prod.amount)}}</div>
            </li>
          </ul>
        </template>
        <template v-if="refundList && refundList.length > 0">
          <hr>
          <div><div>退款資訊</div><div></div></div>
          <ul class="refundList">
            <li v-for="(prod, p) in refundList" :key="`refund-${p}`">
              <div>{{moment(prod.refundTransactionDate).format('YYYY-MM-DD HH:mm')}}</div>
              <div>{{formatDollarInt(prod.refundAmount)}}</div>
            </li>
          </ul>
        </template>
        <template v-if="products && products.length > 0">
          <hr>
          <div><div>商品名稱</div><div></div></div>
          <ul class="products">
            <li v-for="(prod, p) in products" :key="`prd-${p}`"><div>{{p+1}}.</div><div>{{prod.name}}</div><div>x{{prod.quantity}}</div><div>{{formatDollarInt(prod.price)}}</div></li>
          </ul>
        </template>
      </div>
      <div class="btns" :class="((refundList||[]).length>0) && 'b1'">
        <button :style="{backgroundColor:'#CACACA'}" @click="$emit('close')">關閉</button>
        <button v-if="!((refundList||[]).length>0)" :style="{backgroundColor:'var(--highlight)'}" @click="$emit('refund')" :disabled="waiting">退款</button>
      </div>
    </template>
    <template v-else>
    <div class="error">{{error}}</div>
    <div class="btns b1">
      <button :style="{backgroundColor:'#CACACA'}" @click="$emit('close')">關閉</button>
    </div>
    </template>
  </div>
</template>

<script>
export default {
  props: ['data', 'error', 'transactionId', 'waiting'],
  computed: {
    data2 () {
      return Object.assign({}, ...Object.keys(this.data).filter(e => this.data[e]).map(k => { return { [k]: this.data[k] } }))
    },
    TradeStatus () {
      switch (parseInt(this.data.TradeStatus)) {
        case 0:
          return '未付款'
        case 1:
          return '已付款'
        case 10200095:
          return '交易訂單未成立'
        default:
          return ''
      }
    },
    amount () {
      return this.payInfo.map(e => e.amount).reduce((a, b) => a + b, 0)
    },
    payInfo () {
      return this.data?.payInfo
    },
    refundList () {
      return this.data?.refundList
    },
    products () {
      return [].concat(...this.data?.packages.map(e => e.products))
    }
  }

}
</script>

<style lang="scss" scoped>
hr {
  height: 1px;
  margin-block: .5em;
  width: 100%;
  background-color: #CACACA;
  border: none;
}
.error {
  font-size: 30px;
  color: var(--highlight);
  letter-spacing: .05em;
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.refundList {
  padding-left: 1em;
  li {
    display: grid;
    grid-template-columns: 3fr 1fr;
    &>div{
      text-align: start;
      &:last-child {
        text-align: end;
      }
    }
  }

}
.products {
  padding-left: 1em;
  li {
    display: grid;
    grid-template-columns: 20px 2fr 40px 1fr;
    &>div{
      text-align: start;
      &:last-child {
        text-align: end;
      }
    }
  }
}
.btns {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 35px;
  height: 60px;
  button {
    font-size: 20px;
    letter-spacing: .05em;
    color: #FFFFFF;
    border-radius: 3px;
    &:disabled {
      filter: contrast(.5);
    }
  }
  &.b1 {
    grid-template-columns: 1fr;
  }
}
.diabox {
  padding: 20px 40px;
  display: flex;
  flex-direction: column;
  gap: 40px;
}
.exp>div {
  display: grid;
  align-items: center;
  grid-template-columns: 130px 1fr;
  text-align: start;
  align-items: center;
  height: 40px;
  font-size: 18px;
}
</style>
